
<script>
import TableTopBar from '../Toolbar/TableTopBar'
import PageColumnItem from '../PageColumnItem'
import PageTableItem from "@/components/Pages/PageTable/PageTableItem";

export default {
  name: 'PageTable',
  components: {PageColumnItem, PageTableItem, TableTopBar },
  model: {
    prop: '',
    event: 'submit'
  },
  data () {
    return {
      dialogShow: false,
      tableBodyHeight: 0,
      tableData: [],
      tableButtons: {},
      dialogValue: { value: { } }
    }
  },
  props: {
    title: {
      type: String,
      default: '信息'
    },
    tableColumnAttributes: {
      type: Array,
      require: true
    },
    showTableToolbar: {
      type: Boolean,
      default: true
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Number,
      default () {
        return this.ButtonEnums.TableButtons.descriptionButton |
                this.ButtonEnums.TableButtons.updateButton |
                this.ButtonEnums.TableButtons.deleteButton
      }
    },
    toolbarButtons: Number,
    dialogModel: {
      type: Number,
      default () {
        return this.Models.DialogModel.addModel
      }
    },
    value: {
      type: [Object, Array],
      default () {
        return {}
      }
    },
    submitButtonType: {
      type: Number,
      default () {

      }
    },
    handleColumn: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    handleWidth: {
      type: Number,
      default: 260
    },
    exportUrl: {
      type: String,
      default: "",
    },
    searchModel: {
      type: Object,
    }
  },
  methods: {
    onHeightChange (height) { // 高度改变事件
      this.tableBodyHeight = height + 1
    },
    onAddClick () { // 添加按钮事件
      this.$emit('add-click')
    },
    onDeleteAllSelectClick () { // 删除全部选中项目事件
      this.$emit('delete-all-click')
    },
    onSearchClick (searchData) { // 搜索按钮事件
      this.$emit('search-click', searchData)
    },
    onImport(){ //导入
      this.$emit('import-click')
    },
    onExport(){ //导出
      let form = this.searchModel,
        url = this.exportUrl;
      form.rowCodes = "";
      this.$http.exportFile(url,form).then(res=>{
          const blob = new Blob([res.data],{type: "charset=utf-8"});//,{type: 'application/vnd.ms-excel;charset=utf-8'}
          let fileName = res.headers['filename'];
          const elink = document.createElement('a');
          elink.download = decodeURI(fileName);
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
      })
      this.$emit('export')
    },
    onDescriptionButton ({ row, column, $index }) { // 查看/详情按钮单击事件
      this.$emit('look-click', row, column, $index)
      this.dialogShow = true
    },
    onDeleteButton ({ row, column, $index }) { // 删除按钮点击事件
      this.$emit('delete-click', row, column, $index)
    },
    onUpdateButton ({ row, column, $index }) { // 修改按钮点击事件
      this.$emit('update-click', row, column, $index)
      this.dialogShow = true
    },
    onAdvancedButton ({ row, column, $index }) { // 高级按钮点击事件
      this.$emit('advanced-click', row, column, $index)
    },
    checkTableColumnAttributeType (propName) { // 检查表格列类型
      for (let i = 0; i < this.tableColumnAttributes.length; i++) {
        if (this.tableColumnAttributes[i].prop === propName) {
          return this.tableColumnAttributes[i].type || 'String'
        }
      }
      return 'String'
    },
    closeDialog () {
      this.dialogShow = false
      this.$emit('close', this.dialogShow)
    },
    openDialog () {
      // this.GlobalEvent.openDialog()
    },
    onColumnItemClick(value, row, $index){
      this.$emit('column-item-click', value, row, $index)
    },
    renderTableAndTopBor (createElement){
        const nodes = []
        let that = this
        //创建工具栏
        if (that.showTableToolbar){
            const slot = this.$slots['advanced-search']
            nodes.push(
                createElement('div',{attrs:{
                        'class': 'page-top-bor-container'
                    }},[
                    createElement(TableTopBar, {
                            on:{
                                'add-click': that.onAddClick,
                                'delete-all-select-click': that.onDeleteAllSelectClick,
                                'search-click': that.onSearchClick,
                                'height-change': that.onHeightChange,
                                'import': that.onImport,
                                'export': that.onExport,
                            },
                            props: {
                                buttonStatus: this.toolbarButtons
                            }
                        },
                        slot
                    )
                ])
                )
        }
        //创建表格列
        const columns = [
            ...that.renderCheckboxColumn(createElement),
            ...that.renderIndexColumn(createElement),
            ...that.renderPropsColumn(createElement, that.tableColumnAttributes)
        ]

        //操作列
        if (this.handleColumn){
            columns.push(createElement('el-table-column', {
                props: {
                    align: 'center',
                    fixed: 'right',
                    label: '操作',
                    width: this.handleWidth
                },
                scopedSlots: {
                    default: props=>{
                        const {row, column, $index} = props
                        //按钮
                        const buttonArray = []
                        const $this = this
                        if (this.buttons & this.tableButtons.descriptionButton){
                            buttonArray.push(createElement('el-button', {
                                on: {
                                    click: ()=>{
                                        this.onDescriptionButton({ row, column, $index })
                                    }
                                },
                                props:{
                                    type: 'primary',
                                    size: 'small',
                                    icon: 'el-icon-view'
                                }
                            }, '查看'))
                        }
                        if (this.buttons & this.tableButtons.updateButton){
                            buttonArray.push(createElement('el-button', {
                                on: {
                                    click: () =>{
                                        this.onUpdateButton({ row, column, $index })
                                    }
                                },
                                props:{
                                    type: 'primary',
                                    size: 'small',
                                    icon: 'el-icon-edit'
                                }
                            }, '编辑'))
                        }
                        if (this.buttons & this.tableButtons.deleteButton){
                            buttonArray.push(createElement('el-button', {
                                on: {
                                    click: () =>{
                                      this.onDeleteButton({ row, column, $index })
                                    }
                                },
                                props:{
                                    type: 'danger',
                                    size: 'small',
                                    icon: 'el-icon-delete'
                                }
                            }, '删除'))
                        }
                        if (this.buttons & this.tableButtons.advancedButton){
                            buttonArray.push(createElement('el-button', {
                                on: {
                                    click:() =>{
                                        this.onAdvancedButton({ row, column, $index })
                                    }
                                },
                                props:{
                                    type: 'success',
                                    size: 'small',
                                    icon: ''
                                }
                            }, '高级'))
                        }
                        if (this.$slots.buttons || this.$scopedSlots.buttons){
                            let scope = {row, column, $index},
                                buttons = this.$slots.buttons || this.$scopedSlots.buttons
                            buttonArray.push(buttons(scope))
                        }
                        return createElement('el-button-group', {}, buttonArray)
                    }
                }
            }))
        }
        //创建表格
        nodes.push(createElement('div',{
            attrs: {
                'class': 'page-table-body'
            }
        }, [createElement('el-table', {
            on: {
              selectionChange:(params) =>{
                  this.$emit('onSelection', params)
                  // console.log(params)
              }
            },
            props: {
                data: that.value,
                border: true,
                height: '100%',
                size: 'medium',
            },
            attrs: {
                style: 'width: 100%;'
            },
            directives:[
                {
                    name: 'loading',
                    value: that.loading,
                }
            ]
        },columns)]))
        return nodes
    },
      // index 列
      renderIndexColumn(createElement){
        //放进数组完全是为了方便 以后扩展也会方便一些
        return [createElement('el-table-column',{
            props:{
                type: 'index',
                align: 'center',
                index: 1,
                label: '序号',
                width: "56"
            }
        })]
      },
      // checkbox 列
      renderCheckboxColumn(createElement){
          if (this.showCheckbox){
              return [createElement('el-table-column',{
                  on: {
                    click: function(val){
                      console.log(val)
                    }
                  },
                  props:{
                      type: 'selection',
                      align: 'align',
                      index: '1',
                      width: '55'
                  },
              })]
          }
          return []
      },
      //创建属性生成列
      renderPropsColumn(createElement, props){
        if (!props || props.length === 0){
            return []
        }
        const nodes = []
          for (let i = 0; i < props.length; i++) {
              const cache = props[i]
              const that = this
              if (cache.children && cache.children.length > 0){
                  nodes.push(createElement('el-table-column', {
                      props: {
                          align: 'center',
                          prop: cache.prop,
                          label: cache.label,
                          minWidth: cache.minWidth || 180,
                          showOverflowTooltip: true,
                          width: cache.width
                      }
                  },[...that.renderPropsColumn(createElement, cache.children)]))
              }else{
                  nodes.push(createElement('el-table-column', {
                      props: {
                          align: 'center',
                          prop: cache.prop,
                          label: cache.label,
                          minWidth: cache.minWidth || 180,
                          showOverflowTooltip: true,
                          width: cache.width
                      },
                      scopedSlots: {
                          default: props=>{
                              const { row, column, $index} = props
                              return createElement('page-column-item',
                                  {
                                      props: {
                                          value: row[column.property],
                                          type: cache.type,
                                          row: row,
                                          $index: $index
                                      },
                                      on:{
                                          'column-item-click': this.onColumnItemClick
                                      }
                                  })
                          }
                      }
                  }))
              }
          }
          return nodes
      }
  },
  mounted () {
    this.tableButtons = this.ButtonEnums.TableButtons
    //this.GlobalEvent.onCloseDialog(this.closeDialog)
  },
  render(createElement) {
      return createElement('div', {
          class: 'common-body page-table-container'
      }, [...this.renderTableAndTopBor(createElement)])
  }
}
</script>

<style scoped lang="scss">
    .page-table-container {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .page-top-bor-container{
            height: 60px;
        }
        .page-table-body {
            flex-grow: 1;
            min-height: 0;
        }
    }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageTable/index.vue"
}
</vue-filename-injector>
